<template>
  <div id="app">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <div class="logo">
          <img src="./assets/imges/logo.png" alt="">
        </div>
        <div class="header-title">
          招生管理系统
          <span style="font-size: 14px">
              (招生咨询电话：0561-3128888)
          </span>
        </div>
      </div>
      
      <!-- <div class="desc">
        (原淮北师范大学信息学院)
      </div> -->
      
      <div>
        <el-button type="primary" v-show="tokens" @click="edit_token">退出登录</el-button>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
    <div class="btn-back" v-show="btnSign">
      <el-button type="primary" @click="goBreack">返回</el-button>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        btnSign: false,
        tokens:false
      }
    },
    watch: {
	    $route () {
	        if (localStorage.getItem("token") != null) {
	          this.tokens=true
	        }else{ 
            this.tokens=false
	        }
	    }
	  },
    mounted() {
      let query = this.$route.query
      if (query.backSign || query.backSign == true)
        this.btnSign = true
      else
        this.btnSign = false
    },
    methods: {
      
      // 返回
      goBreack() {
        this.btnSign = false
        this.$router.go(-1)
      },
      edit_token(){
        this.$confirm('确定退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          localStorage.removeItem('token');
          this.$router.push({path: '/login'})
        }).catch(() => {})
      },
      getList() {
        this.$http.post('/api/auth/login', {}).then(res => {

        })
      }
    }
  }
</script>
<style scoped>
  .header {
    width: 100%;
    min-height: 100px;
    background-color: #2e6fb8;
    display: flex;
    justify-content: space-between;
    padding:0 100px;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
  }

  .header .logo {
    /* margin-right: 0px; */
    /* margin-left: 100px; */
  }

  .header .logo img {
    /* width: 400px; */
    height: 60px;
  }

  .header .desc {
    color: #fff;
  }

  .header .header-title {
    font-size: 26px;
    padding-left: 30px;
  }

  .content {
    width: 95%;
    margin: 0 auto;
    padding: 20px;
  }

  .btn-back {
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>